import { motion } from "framer-motion";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Work from "@/sections/Work";
import { EASE } from "@/components/motion";

export default function WorkPage() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, ease: EASE }} className="bg-paper">
      <Nav />
      <main className="pt-20 sm:pt-24">
        <Work />
      </main>
      <Footer />
    </motion.div>
  );
}
